import { render } from "./TicketSchedules.vue?vue&type=template&id=4656ea5c"
import script from "./TicketSchedules.vue?vue&type=script&lang=js"
export * from "./TicketSchedules.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__